<div class="recommendation-badge-wrapper">
    <div id="recommendation-badge">
        <img id="recommendation-icon" src="../../../assets/icons/rating/rating.svg" alt="recommendation icon" />
        <span id="recommendation-text">Recommended</span>
    </div>
</div>